"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Category;
(function (Category) {
    Category["PONTOON"] = "pontoon";
    Category["FISHING_BOAT"] = "fishing boat";
    Category["DECK_BOAT"] = "deck boat";
    Category["HOUSEBOAT"] = "houseboat";
    Category["CATAMARAN"] = "catamaran";
    Category["YACHT"] = "yacht";
    Category["SPEED_BOAT"] = "speed boat";
    Category["BOW_RIDER"] = "bow rider";
    Category["MEGA_YACHT"] = "mega yacht";
    Category["SUPER_YACHT"] = "super yacht";
    Category["CENTER_CONSOLE"] = "center console";
    Category["SPORT_YACHT"] = "sport yacht";
    Category["CUSTOM_BOAT"] = "custom boat";
    Category["SAILBOAT"] = "sailboat";
})(Category = exports.Category || (exports.Category = {}));
